import script from "./MainHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHome.vue?vue&type=script&setup=true&lang=js"

import "./MainHome.css?vue&type=style&index=0&id=29a560d7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a560d7"]])

export default __exports__